import { render } from "./HelpView.vue?vue&type=template&id=bebdbd04"
const script = {}

import exportComponent from "C:\\Users\\Tony\\Documents\\SourceTree\\novatrans-spotlight\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__